<script>
import { saveAs } from 'file-saver/FileSaver'
import { date } from 'quasar'
import { toArrayBuffer, formatDate } from 'src/utils'
import { mapActions, mapMutations, mapState } from "vuex";
import CourseAutocomplete from '../Course/CourseAutoComplete'
const today = new Date()
const { startOfDate, addToDate, subtractFromDate } = date
export default {
  name: "accountingReport",
  data() {
    return {
      maximized: false,
      reportType: null,
      selectedOrderType: null,
      selectedReportType: 'class',
      reportTypes:[
        {
          label: 'Class',
          value: 'class'
        },
        {
          label: 'Order',
          value: 'order'
        }
      ],
      course_id: null,
      startDate: null,
      endDate: null,
      today,
      tomorrow: addToDate(today, { days: 1 }),
      yesterday: subtractFromDate(today, { days: 1 })
    };
  },
  computed: {
    ...mapState({
      accountingReportModal: s => s.shared.accountingReportModal,
      orderTypes: s => s.shared.orderTypes
    })
  },
  components: {
    CourseAutocomplete
  },
  valdiations(){
    return {}
  },
  methods: {
    ...mapMutations(["closeModal"]),
    ...mapMutations("reports", ["changeState"]),
    ...mapActions("reports", [ "generateAccountingReport"]),
    toggleMaximized() {
      this.maximized = !this.maximized;
    },
    onSelectCourse(course){
      this.course_id = course ? course.item.COURSE_ID : null
    },
    runReport () {
      
      let payload = {
        end_date: this.endDate,
        start_date: this.startDate,
        course_id: this.course_id,
        lk_order_type_id: this.selectedOrderType,
        reportType: this.selectedReportType
      }
      console.log(payload)
      this.generateAccountingReport(payload)
      .then(response => {
        if(response) {
          saveAs(
            new Blob([toArrayBuffer(response.content.data)],
            { type: 'application/octet-stream' }),
            this.getTitle(this.startDate, this.endDate, this.selectedReportType, this.course_id, this.selectedOrderType),
          )
        }
      })
    },
    getTitle(start, end, type, course_id, order_type_id) {
      type = _.capitalize(type) + `${type == 'class' ? 'es' : 's'}`
      const formatTitleDate = (d) => d.split('T')[0]
      const title_start = start ? formatTitleDate(start) : '1900-1-1'
      const title_end = end ? formatTitleDate(end) : '2100-1-1'
      let title = `${type} for ${title_start}-${title_end}`
      if (course_id) {
        title += ` Course ID ${course_id}`
      } else {
        title += ` Order Type ${order_type_id ? order_type_id : 'All'}`
      }
      return `${title}.xlsx`
    },
  }
};
</script>

<template>
  <q-modal class="sl-modal"
  id="accountingReportModal"
  :maximized="maximized"
  :value="accountingReportModal"
  @hide="closeModal('accountingReport')"
  >
  <q-modal-layout>
    <q-toolbar slot="header">
      <q-toolbar-title>
        <q-icon name="fa fa-money" /> Accounting Report
      </q-toolbar-title>
      <!--<q-icon @click.native="toggleMaximized()" size="20px" class="gt-sm" name="filter_none" />-->
      <q-icon @click.native="closeModal('accountingReport')" name="clear" />
    </q-toolbar>
    <div style="padding:40px 20px">
      <div class="sl-row">
        <div class="sl-col-12">
            <p style="max-width:350px; margin:0 auto" class="text-center">This report shows all the classes and fees collected for a given date range.</p>
        </div>
      </div>
      <div class="sl-row">
        <div class="sl-col-12">
          <q-field>
            <q-select
              float-label="Report Type"
              v-model="selectedReportType"
              :options="reportTypes"
              clearable
              autofocus-filter
            />
          </q-field>
        </div>
      </div>
      <div class="sl-row" style="margin:0">
        <div class="sl-col-6">
          <q-datetime stack-label="Start Date" v-model="startDate" :max="today" />
        </div>
        <div class="sl-col-6">
          <q-datetime stack-label="End Date" v-model="endDate" :max="today" />
        </div>
      </div>
      <div class="sl-row q-mb-none">
        <div class="sl-col-12" v-if="selectedReportType === 'class'">
          <course-autocomplete :select="onSelectCourse" />
        </div>
        <div class="sl-col-12" v-if="selectedReportType === 'order'">
          <!-- ..{{orderTypes}}.. -->
          <q-field>
            <q-select
              float-label="Order Type"
              v-model="selectedOrderType"
              :options="orderTypes"
              clearable
              filter
              autofocus-filter
            />
          </q-field>
        </div>
      </div>
    </div>
      <q-toolbar slot="footer">
        <q-toolbar-title></q-toolbar-title>
        <q-btn color="green" @click.native="runReport()" icon="fa fa-gear" label="Run" />&nbsp;
        <q-btn outline color="faded" @click.native="closeModal('accountingReport')" label="Cancel" />
      </q-toolbar>
    </q-modal-layout>
  </q-modal>
</template>

<style lang="stylus">
</style>